import { Sparkles } from 'lucide-react'
import type { Insight } from '@movmania/core'
import { ICON_STROKE } from '../lib/icons.js'
import { useT } from '../lib/useT.js'

/**
 * Le "pic" de l'expérience : une observation sur QUI est l'utilisateur, pas
 * sur ce qu'il a fait. « Tu es du genre à tenir dans la durée » vaut mieux que
 * « 3 séances cette semaine » — et c'est ce qui donne envie de partager.
 */
export function InsightCard({ insight }: { insight: Insight }) {
  const t = useT()
  const vars: Record<string, string | number> = { ...insight.vars }
  if (typeof vars['activity'] === 'string') {
    vars['activity'] = t(`activityType.${vars['activity']}`)
  }
  if (typeof vars['moment'] === 'string') {
    vars['moment'] = t(`moment.${vars['moment']}`)
  }
  if (typeof vars['day'] === 'string') {
    vars['day'] = t(`weekday.${vars['day']}`)
  }

  return (
    <div className="bg-green-soft flex items-start gap-3 rounded-[var(--radius-card)] p-5">
      <span className="bg-surface text-green grid size-10 shrink-0 place-items-center rounded-full">
        <Sparkles size={18} strokeWidth={ICON_STROKE} aria-hidden="true" />
      </span>
      <p className="text-body text-ink self-center font-semibold">
        {t(`insight.${insight.kind}`, vars)}
      </p>
    </div>
  )
}
